// A $( document ).ready() block.
$( document ).ready(function() {
    var autoplay = {
        delay: 5000,
        disableOnInteraction: false
    }
    
    // var next = $(this).closest('.js-swiper-wrapper').find('.swiper-button-next');
    // var prev = $(this).closest('.js-swiper-wrapper').find('.swiper-button-prev');
    $('.swiper-hero').each(function() {
        new Swiper($(this)[0], {           
            pagination: {
                el: ".b-slider .swiper-pagination",
                clickable: true
            },      
            snapOnRelease: true,
            effect: "fade",
            // autoplay,
            speed:1000,
            loop: true,
            slidesPerView: 1
        }); 

        // setTimeout(function() {
        //     $('.swiper-wrapper .swiper-slide:not(:first-child)').css('opacity', '1');
        // }, 500);                
    });    
    $('.jas-product-img-element').matchHeight();
    $('.product-grid-item .product-title').matchHeight();
    
    // $('.jas-product-img-element').matchHeight({byRow:false});
    
});